/**
 * 描述：级联菜单
 * 作者：Bai.Zhiming
 * 日期：2017-10-12
 */
'use strict';
angular.module('cascadingMenuModule', []).directive('cascadingMenu', [
    '$q',
    '$compile',
    'trsspliceString',
    '$timeout',
    function($q, $compile, trsspliceString, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                showName: '@',
                showId: '@',
                callback: '&',
                casData: '=',
                isSingle: '@',
                placeholder: '@',
                leveloneSelectable: '@',
                // 判断是否能够选择的参数string
                canSelectCheck: '@',
                // 判断是否展示按钮（小图标替代）
                isHide: '@',
                // 判断是否不需要清除其他对象数据
                needNotClean: '@',
                // 定位点的左右偏移量
                leftMove: '@'
            },
            templateUrl: './components/util/cascadingMenu/cascadingMenu_tpl.html',
            link: function(scope, $elem, $attrs) {
                initStatus();
                initData();
                scope.$watch('casData', function(newVal, oldVal) {
                    scope.data.selectedNodes = angular.isArray(newVal) ? newVal : [];
                });

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        showSelectedFn: $attrs.showSelected,
                        randomId: 'cas_' + parseInt(Math.random() * 10000),
                    };
                    scope.data = {
                        treeData: [],
                        selectedNodes: angular.isArray(scope.casData) ? scope.casData : [],
                    };
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    fixScroll();
                    initBlur();
                    destroyList();
                }

                /**
                 * [destroyList description] 销毁下拉列表
                 * @return {[type]} [description]
                 */
                function destroyList() {
                    scope.$on('$destroy', function() {
                        $('.cascadingMenu_ul').remove();
                    });
                }

                /**
                 * [fixScrollPostion description] 执行修正鼠标滚动后的位置变化
                 * @return {[type]} [description]
                 */
                function fixScroll() {
                    $('body')
                        .unbind('mousewheel', fixScrollPostion)
                        .bind('mousewheel', fixScrollPostion);
                    scope.$on('$destroy', function() {
                        $('body').unbind('mousewheel', fixScrollPostion);
                    });
                    $('body').delegate('.cascadingMenu_ul', 'mousewheel', function(event) {
                        // 阻止冒泡
                        event.stopPropagation();
                    });
                }

                var fixPromise;

                /**
                 * [fixScrollPostion description] 修正鼠标滚动后的位置变化
                 * @return {[type]} [description]
                 */
                function fixScrollPostion(e) {
                    if ($('.cascadingMenu_ul').length != 0) {
                        close();
                    }
                }

                /**
                 * [myBlur description] 组件失焦
                 * @return {[type]} [description]
                 */
                function initBlur() {
                    $('html')
                        .unbind('click', myBlur)
                        .bind('click', myBlur);

                    function myBlur($event) {
                        var $target = $($event.target);
                        if ($('.cascadingMenu_ul').length === 0) {return;}
                        if (
                            $target.parents('.cascadingMenu').length <= 0 &&
                            $target.parents('.cascadingMenu_ul').length <= 0 &&
                            $("*[randomId='" + scope.status.randomId + "']").length > 0
                        ) {
                            close();
                        }
                    }
                    scope.$on('$destroy', function() {
                        $('html').unbind('click', myBlur);
                    });
                    // $("html").bind("click", close);
                    // $("html").bind("mouseover", removeChildren);
                }

                /**
                 * [close description] 关闭组件
                 * @return {[type]} [description]
                 */
                function close() {
                    $('.cascadingMenu_ul').remove();
                    $('html').unbind('click', close);
                    $('html').unbind('mouseover', removeChildren);
                    $timeout(function() {
                        scope.status.open = false;
                        scope.callback();
                    });
                }

                /**
                 * [removeChildren description] 删除所有子菜单
                 * @return {[type]} [description]
                 */
                function removeChildren(e) {
                    var $current = $(e.target);
                    if (
                        $current.parents('.cascadingMenu_ul').length === 0 &&
                        $current.attr('class') !== undefined &&
                        $current.attr('class').indexOf('cascadingMenu_ul') < 0
                    ) {
                        $('.cascadingMenu_ul_children').remove();
                    }
                }

                /**
                 * [clickButton description] 点击按钮
                 * @param {dom} [$event] [description] 点击的dom元素
                 * @return {[type]} [description]
                 */
                scope.clickButton = function($event) {
                    if (!isOpen()) {
                        scope.showSelected({}).then(function(data) {
                            var beforLeft = scope.leftMove ? scope.leftMove : 0;
                            scope.data.treeData = data;
                            var btnTop = $elem.offset().top;
                            var btnLeft = $elem.offset().left - beforLeft;
                            var btnHeight = $elem.height();
                            var bodyHeight = $('body').height();
                            var chooseTool;
                            var chooseEvent;
                            if (scope.leveloneSelectable === 'true') {
                                chooseTool =
                                    scope.isSingle === 'true'
                                        ? "<trs-single-radio ischecked='nodeIsChecked(item).flag'></trs-single-radio>"
                                        : "<trs-checkbox ischecked='nodeIsChecked(item).flag'></trs-checkbox>";
                                chooseEvent = 'ng-click=selectNode($event,item)';
                            } else {
                                chooseTool = '';
                                chooseEvent = '';
                            }
                            var $ul = $(
                                [
                                    "<ul class='cascadingMenu_ul " +
                                        (scope.leveloneSelectable == 'false' ? 'leveloneUnselectable' : '') +
                                        "' randomId='" +
                                        scope.status.randomId +
                                        "'>",
                                    "<li ng-class={'selected':nodeIsChecked(item).flag} ",
                                    chooseEvent,
                                    " ng-repeat='item in data.treeData track by $index' ng-mouseenter='levelOneMouseenter($event,item,$index)'>",
                                    chooseTool,
                                    "<span class='name' title='{{item." + scope.showName + "}}' ng-bind='item." + scope.showName + "'></span>",
                                    '</li>',
                                    '</ul>',
                                ].join('')
                            );
                            $ul = $compile($ul)(scope);
                            $ul.css({
                                top: btnTop + btnHeight,
                                left: btnLeft,
                                maxHeight: 210, // 原来：bodyHeight - (btnTop + btnHeight) 因测试要求
                            });
                            $('body').append($ul);
                        });
                        scope.status.open = true;
                    } else {
                        close();
                    }
                };

                /**
                 * [isOpen description] 判断组件是否打开
                 * @return {Boolean} [description]
                 */
                function isOpen() {
                    return $('.cascadingMenu_ul').length > 0;
                }

                /**
                 * [levelOneMouseenter description] 一级菜单，鼠标移入事件
                 * @param  {[type]} $event [description]
                 * @return {[type]}        [description]
                 */
                scope.levelOneMouseenter = function($event, item, index) {
                    $($event.currentTarget)
                        .parent()
                        .find('li')
                        .removeClass('hasChildren');
                    $($event.currentTarget)
                        .parents('.cascadingMenu_ul')
                        .nextAll('.cascadingMenu_ul')
                        .remove();
                    // $($event.currentTarget).siblings().find("ul").remove();
                    var cName = 'item' + item[scope.showId];
                    var theScope = $($event.currentTarget).data().$scope;
                    if (angular.isDefined(scope.data.treeData[index].CHILDREN) && scope.data.treeData[index].CHILDREN.length > 0) {
                        if (item.hasChildren || item.CHILDREN) {
                            $($event.currentTarget).addClass('hasChildren');
                        }
                        appendChild();
                    } else {
                        scope.showSelected(item).then(function(data) {
                            item.CHILDREN = data;
                            if (!!data && data.length > 0 && angular.isArray(data)) {
                                $($event.currentTarget).addClass('hasChildren');
                                appendChild();
                            }
                        });
                    }

                    function appendChild() {
                        // var chooseAll = scope.isSingle ==='true' ? '' : '<li>全部</li>';
                        var moreClass = '';
                        if (scope.canSelectCheck) {
                            if(!item[scope.canSelectCheck]) {
                                moreClass = 'leveloneUnselectable';
                            };
                            var chooseTool =
                                item[scope.canSelectCheck]
                                    ? scope.isSingle === 'true'
                                        ? "<trs-single-radio ischecked='nodeIsChecked(" + cName + ").flag'></trs-single-radio>"
                                        : "<trs-checkbox ischecked='nodeIsChecked(" + cName + ").flag'></trs-checkbox>"
                                    : '';
                        } else {
                            var chooseTool =
                                scope.isSingle === 'true'
                                    ? "<trs-single-radio ischecked='nodeIsChecked(" + cName + ").flag'></trs-single-radio>"
                                    : "<trs-checkbox ischecked='nodeIsChecked(" + cName + ").flag'></trs-checkbox>";
                        }
                        var selectAll =
                            scope.isSingle !== 'true'
                                ? "<li ng-click='selectAll(item,$event)' ng-class={'selected':isSelectedAll(item).flag}><trs-checkbox ischecked='isSelectedAll(item).flag'></trs-checkbox>全选</li>"
                                : '';
                        var $ul = [
                            "<ul class='cascadingMenu_ul cascadingMenu_ul_children " + moreClass + "' randomId='" + scope.status.randomId + "'>",
                            selectAll,
                            "<li ng-class={'selected':nodeIsChecked(" +
                                cName +
                                ").flag} ng-click='selectNode($event," +
                                cName +
                                ")' ng-mouseenter='mouseenter($event," +
                                cName +
                                ',"' +
                                cName +
                                "\")' ng-repeat='" +
                                cName +
                                " in item.CHILDREN'>",
                            chooseTool,
                            "<span class='name' title='{{" + cName + '.' + scope.showName + "}}' ng-bind='" + cName + '.' + scope.showName + "'>",
                            '</span>',
                            '</li>',
                            '</ul>',
                        ].join('');
                        $ul = $compile($ul)(theScope);
                        var $parent = $('.cascadingMenu_ul');
                        var parentTop = $parent.offset().top;
                        var parentLeft = $parent.offset().left;
                        var parentWidth = $parent[0].offsetWidth - 2;
                        var bodyHeight = $('body').height();
                        $ul.css({
                            top: parentTop,
                            left: parentLeft + parentWidth,
                            maxHeight: 210, // 原来：bodyHeight - parentTop 因测试要求
                        });
                        $ul.insertAfter($parent);
                    }
                };

                /**
                 * [selectAll description] 全选
                 * @return {[type]} [description]
                 */
                scope.selectAll = function(item, $event) {
                    $event.stopPropagation();
                    var flag = scope.isSelectedAll(item).flag;
                    if (flag) {
                        for (var j = 0; j < item.CHILDREN.length; j++) {
                            var child_ = item.CHILDREN[j];
                            scope.selectNode('', child_);
                        }
                    } else {
                        var brothers = $($event.target).siblings();
                        for (var k = 0; k < item.CHILDREN.length; k++) {
                            var child__ = item.CHILDREN[k];
                            if (!scope.nodeIsChecked(child__).flag) {
                                var event = {
                                    currentTarget: brothers[k],
                                };
                                scope.selectNode(event, child__);
                            }
                        }
                    }
                };

                /**
                 * [isSelectedAll description] 是否已全选
                 * @return {Boolean} [description]
                 */
                scope.isSelectedAll = function(item) {
                    var flag = true;
                    if (angular.isUndefined(item.CHILDREN)) {return false;}
                    for (var i = 0; i < item.CHILDREN.length; i++) {
                        var child = item.CHILDREN[i];
                        if (!scope.nodeIsChecked(child).flag) {
                            flag = false;
                            break;
                        }
                    }
                    return { flag: flag };
                };

                /**
                 * [mouseenter description] 普通鼠标移入事件
                 * @param  {[type]} $event [description]
                 * @param  {[type]} item   [description]
                 * @return {[type]}        [description]
                 */
                scope.mouseenter = function($event, item, name) {
                    $($event.currentTarget)
                        .parents('.cascadingMenu_ul')
                        .eq(0)
                        .find('li')
                        .removeClass('hasChildren');
                    $($event.currentTarget)
                        .parents('.cascadingMenu_ul')
                        .nextAll('.cascadingMenu_ul')
                        .remove();
                    if (item.hasChildren != 0) {
                        var cName = 'item' + item[scope.showId];
                        var theScope = $($event.currentTarget).data().$scope;

                        // var $ul = $compile("<ul><li ng-repeat='item in data.levelOne' ng-mouseenter='mouseenter($event,item)' ng-mouseleave='mouseleave($event,item)'><span ng-bind='item.name'></span></li></ul>")(scope);
                        // $($event.currentTarget).append($ul);
                        if (
                            angular.isDefined(item.CHILDREN) &&
                            (angular.isObject(item.CHILDREN) || angular.isArray(item.CHILDREN)) &&
                            item.CHILDREN.length > 0
                        ) {
                            appendChild();
                        } else {
                            scope.showSelected(item).then(function(data) {
                                item.CHILDREN = data;
                                if (!!data && data.length > 0 && angular.isArray(data)) {
                                    appendChild();
                                }
                            });
                        }
                    }

                    /**
                     * [appendChild description]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function appendChild() {
                        $($event.currentTarget).addClass('hasChildren');
                        var selectAll =
                            scope.isSingle !== 'true'
                                ? "<li ng-class={'selected':isSelectedAll(" +
                                  name +
                                  ").flag} ng-click='selectAll(" +
                                  name +
                                  ",$event)'><trs-checkbox ischecked='isSelectedAll(" +
                                  name +
                                  ").flag'></trs-checkbox>全选</li>"
                                : '';
                        var chooseTool =
                            scope.isSingle === 'true'
                                ? "<trs-single-radio ischecked='nodeIsChecked(" + cName + ").flag'></trs-single-radio>"
                                : "<trs-checkbox ischecked='nodeIsChecked(" + cName + ").flag'></trs-checkbox>";
                        var $ul = [
                            "<ul class='cascadingMenu_ul cascadingMenu_ul_children' randomId='" + scope.status.randomId + "'>",
                            selectAll,
                            "<li ng-class={'selected':nodeIsChecked(" +
                                cName +
                                ").flag} ng-click='selectNode($event," +
                                cName +
                                ")' ng-mouseenter='mouseenter($event," +
                                cName +
                                ',"' +
                                cName +
                                "\")' ng-repeat='" +
                                cName +
                                ' in ' +
                                name +
                                ".CHILDREN'>",
                            chooseTool,
                            "<span class='name' title='{{" + cName + '.' + scope.showName + "}}' ng-bind='" + cName + '.' + scope.showName + "'>",
                            '</span>',
                            '</li>',
                            '</ul>',
                        ].join('');
                        $ul = $compile($ul)(theScope);
                        var $parent = $('.cascadingMenu_ul_children').eq($('.cascadingMenu_ul_children').length - 1);
                        var parentTop = $parent.offset().top;
                        var parentLeft = $parent.offset().left;
                        var parentWidth = $parent[0].offsetWidth - 2;
                        var bodyHeight = $('body').height();
                        $ul.css({
                            top: parentTop,
                            left: parentLeft + parentWidth,
                            maxHeight: 210, // 原来 bodyHeight - parentTop 因测试要求
                        });
                        $ul.insertAfter($parent);
                    }
                };

                /**
                 * [selectNode description] 选择节点
                 * @param  {[type]} $event [description] 事件
                 * @param  {[type]} node   [description] 节点
                 * @return {[type]}        [description]
                 */
                scope.selectNode = function($event, node) {
                    if ($event !== '' && $event.stopPropagation) {$event.stopPropagation();}
                    if (scope.canSelectCheck) {
                        if (!node[scope.canSelectCheck]) return;
                    }
                    $timeout(function() {
                        var isSelected = scope.nodeIsChecked(node);
                        var flag = isSelected.flag;
                        if (flag) {
                            var i = scope.data.selectedNodes.length - 1;
                            while (i >= 0) {
                                var theNodes = scope.data.selectedNodes[i];
                                var j = theNodes.length - 1;
                                var inFlag = false;
                                innerLoop: while (j >= 0) {
                                    var theInNode = theNodes[j];
                                    if (theInNode[scope.showId] === node[scope.showId]) {
                                        inFlag = true;
                                        break innerLoop;
                                    }
                                    j--;
                                }
                                if (inFlag) {
                                    if (scope.data.selectedNodes.length === 1) {scope.data.selectedNodes[0].splice(scope.data.selectedNodes[0].length - 1, 1);} else {scope.data.selectedNodes.splice(i, 1);}
                                }
                                if (scope.leveloneSelectable !== 'true' && theNodes.length === 1) {
                                    scope.data.selectedNodes.splice(i, 1);
                                }
                                if (JSON.stringify(scope.data.selectedNodes) === '[[]]') {
                                    scope.data.selectedNodes.splice(0, 1);
                                }
                                i--;
                            }
                        } else {
                            var nodes = [];
                            var $dom = $($event.currentTarget);
                            var myData = $dom.data().$scope;
                            for (var k in myData) {
                                if (k.indexOf('item') === 0) {
                                    nodes.push(angular.copy(myData[k]));
                                    break;
                                }
                            }
                            node = getNodeData(nodes, $dom.parent());
                            var myNodes = angular.copy(nodes);
                            if (!scope.needNotClean) myNodes = cleanData(myNodes);
                            if (scope.isSingle === 'true') {
                                scope.data.selectedNodes = [myNodes];
                                scope.casData = [myNodes];
                                close();
                            } else {
                                scope.data.selectedNodes.push(myNodes);
                                nodes.splice(nodes.length - 1, 1);
                                noDuplicate(angular.copy(nodes));
                            }
                            // scope.data.selectedNodes.push(node);
                        }
                    });
                };

                /**
                 * [cleanData description] 清洗数据
                 * @param {object} [data] [description] 要清理的数据
                 * @return {[type]} [description]
                 */
                function cleanData(data) {
                    for (var i = 0; i < data.length; i++) {
                        var obj = data[i];
                        for (var j in obj) {
                            if (j !== scope.showId && j !== scope.showName) {
                                delete obj[j];
                            }
                        }
                    }
                    return data;
                }

                /**
                 * [noDuplicate description] 去除重复
                 * @return {[type]} [description]
                 */
                function noDuplicate(nodes) {
                    for (var i = 0; i < scope.data.selectedNodes.length; i++) {
                        var myNodes = scope.data.selectedNodes[i];
                        var str1 = trsspliceString.spliceString(myNodes, scope.showId, ',');
                        var str2 = trsspliceString.spliceString(nodes, scope.showId, ',');
                        if (str1 === str2) {
                            scope.data.selectedNodes.splice(i, 1);
                        }
                    }
                }

                /**
                 * [getParentNode description] 获取父节点数据
                 * @return {[type]} [description]
                 */
                function getNodeData(nodes, $dom, callback) {
                    for (var j in $dom.data().$scope) {
                        if (j.indexOf('item') === 0) {
                            var data = $dom.data().$scope[j];
                            myUnshift(nodes, angular.copy(data));
                        }
                    }
                    return nodes;
                }

                /*
                 * [myUnshift description] 排重插入
                 * @return {[type]} [description]
                 */
                function myUnshift(datas, data) {
                    var flag = true;
                    for (var i = 0; i < datas.length; i++) {
                        if (datas[i][scope.showId] === data[scope.showId]) {
                            flag = false;
                            break;
                        }
                    }
                    if (flag) {datas.unshift(data);}
                }

                /**
                 * [nodeIsChecked description] 判断节点是否选中
                 * @param  {[type]} nodeIsChecked [description]
                 * @return {[type]}               [description]
                 */
                scope.nodeIsChecked = function(node) {
                    if (scope.canSelectCheck) {
                        if (!node[scope.canSelectCheck]) return {flag: false};
                    }
                    var iIndex = 0;
                    var jIndex = 0;
                    var flag = false;
                    for (var i = 0; i < scope.data.selectedNodes.length; i++) {
                        var theNodes = scope.data.selectedNodes[i];
                        for (var j = 0; j < theNodes.length; j++) {
                            var theInNode = theNodes[j];
                            if (node[scope.showId] === theInNode[scope.showId]) {
                                flag = true;
                                iIndex = i;
                                jIndex = j;
                                break;
                            }
                        }
                    }
                    return {
                        flag: flag,
                        iIndex: iIndex,
                        jIndex: jIndex,
                    };
                };

                /**
                 * [showSelected description]
                 * @param {object} [item] [description] 当前节点
                 * @return {[type]} [description]
                 */
                scope.showSelected = function(item) {
                    var deffer = $q.defer();
                    scope.$parent[scope.status.showSelectedFn](item).then(function(data) {
                        data = data === '"[]"' ? [] : data;
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                };

                /**
                 * [showTitle description] 按钮标题
                 * @return {[type]} [description]
                 */
                scope.showTitle = function() {
                    var title;
                    if (scope.isSingle === 'true') {
                        if (scope.data.selectedNodes.length !== 0) {
                            title = scope.data.selectedNodes[0][scope.data.selectedNodes[0].length - 1]
                                ? scope.data.selectedNodes[0][scope.data.selectedNodes[0].length - 1][scope.showName]
                                : undefined;
                        }
                    }
                    title = angular.isDefined(title) ? title : scope.placeholder;
                    return title;
                };
            },
        };
    },
]);
